import GCarousel from "./g-carousel";
import { fetchRetailRecommendations } from "./g-utils.js";

class ProductRecommendations extends GCarousel {
  constructor() {
    super();
    this.useCustomRecommendation = this.getAttribute('data-use-custom-recommendation') || null
    this.productIsbn = this.getAttribute('data-recommendation-product-isbn') || null
    this.dynamic = true;
  }

  async fetchCustomRecommendations() {
    const productData = [{
      primaryProductId: this.productIsbn
    }]
    const response = await fetchRetailRecommendations({
      type: "product_page",
      products: productData,
      pageSize: this.recommendationsCount
    })

    const productIsbns = response.result.products
      .map(product => product.isbn)
      .join(',')

    return productIsbns
  }

  async fetchItems() {
    let url;

    if (this.useCustomRecommendation === 'true') {
      const fetchedProductsIsbns = await this.fetchCustomRecommendations()
      url = `/search/?section_id=${this.sectionId}&product_ids=${fetchedProductsIsbns}`;
    } else {
      url = `${window.routes.productRecommendationsUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.recommendationsCount}`
    }

    const response = await fetch(url);
    const text = await response.text();
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;
    const newSplideList = tempDiv.querySelector(".splide__list");
    if (newSplideList.childElementCount > 0) {
      this.splideList.innerHTML = newSplideList.innerHTML;
    } else {
      this.setAttribute('aria-hidden', 'true')
    }
    if (this.splide) {
      this.splide.refresh();
    }
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  get productId() {
    return this.dataset.productId;
  }

  get recommendationsCount() {
    return Number(this.dataset.recommendationsCount);
  }
}

customElements.define('product-recommendations', ProductRecommendations);